module.exports = __webpack_public_path__ + "static/img/404.85dbc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/404.jpg
// module id = oJ4t
// module chunks = 1